import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-90cd68ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VanIcon = _resolveComponent("VanIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: "ignore_com-top",
    id: "header",
    style: _normalizeStyle({ background: _ctx.color })
  }, [
    _createElementVNode("div", {
      class: "header",
      style: _normalizeStyle({ background: _ctx.color })
    }, [
      _createElementVNode("div", {
        class: "header-return",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
      }, [
        _createVNode(_component_VanIcon, { name: "arrow-left" })
      ]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", null, _toDisplayString(_ctx.route.meta.title), 1),
        _createElementVNode("span", null, _toDisplayString(_ctx.route.meta.title1), 1)
      ]),
      (_ctx.metaObj.showLogoOut)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "return-login",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goLogin && _ctx.goLogin(...args)))
          }, " 退出 "))
        : _createCommentVNode("", true)
    ], 4)
  ], 4))
}